export const THRESHOLD_TAB_TOOLTIP =
	'An alert is triggered when the metric crosses a threshold.';

export const ANOMALY_TAB_TOOLTIP =
	'An alert is triggered whenever the metric deviates from an expected pattern.';

export const ROUTING_POLICIES_ROUTE =
	'/alerts?tab=Configuration&subTab=routing-policies';
